import { useMemo } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import { AscHeading, AscBaselineAssessmentChart } from '@ascendnow/ascend-components';
import { PLATFORM_ROUTES } from '@platform/constants';

import { useAppSelector } from '../../store/index';
import { getBaselineAssessmentUtilites } from '@ascendnow/shared';
import styles from '@platform/styles/pages/home.module.scss';

export const AscDashboardBaselineAssessment = () => {
    const router = useRouter();
    const { results, averages, globalAverages, fetchingAssessmentResults } = useAppSelector((state) => state.dashboard.baselineAssesment);

    function goToBaselineAssessmentResults() {
        if (results && results.length > 0) {
            router.push(PLATFORM_ROUTES.dashboard_baseline_assessment_results);
        }
    }

    const { generateAverage, generateLabels, generateGlobalAverage } = useMemo(
        () => getBaselineAssessmentUtilites({ results, averages, globalAverages }),
        [results, averages, globalAverages]
    );

    return (
        <div className={styles.section}>
            <div className={styles.sectionHeader}>
                <AscHeading level={5}>Baseline Assessment</AscHeading>
            </div>

            <div
                className={classNames(styles.sectionContent, {
                    [styles.clickable]: !!results?.length,
                })}
                onClick={goToBaselineAssessmentResults}
            >
                <AscBaselineAssessmentChart
                    data={generateAverage(0)}
                    compareData={generateAverage(1)}
                    globalData={globalAverages && generateGlobalAverage()}
                    actionButtonOnClick={() => router.push(PLATFORM_ROUTES.dashboard_baseline_assessment)}
                    title="Behavioral attribute scores"
                    label1={generateLabels(0)}
                    label2={generateLabels(1)}
                    label3="Global Average"
                    chartClassName={styles.chart}
                    loading={fetchingAssessmentResults}
                />
            </div>
        </div>
    );
};
